import React, { useEffect, useState } from "react";
import SettingsIcon from "../../assets/icons/service_entries.svg2";
import SettingsLinks from "./SettingsLinks";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import HelpButton from "../HelpContent/HelpButton";
import CompanyDetailsIcon from "../../assets/icons/briefcase.svg2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import PageHeader from "../Common/PageHeader";
import MyIcon from "../Common/MyIcon";
import Subheading from "../Common/Subheading";
import timezones from "../Builder/nodes/Logic/timezones";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import AccountOverviewIcon from "../../assets/icons/status.svg2";
import MyCollapse from "../Common/MyCollapse";
import WidgetContainer from "../Common/WidgetContainer";
import OrganisationalHiararchy from "./OrganisationalHiararchy";
import InterfaceSetup from "./InterfaceSetup";
import {
  useClearCompanyLogoMutation,
  useGetAccountSettingsDataQuery,
  useUpdateAccountSettingsDataMutation,
} from "../store/slices/settingsSlice";
import ImageUploadInput from "../Builder/nodes/Logic/Inputs/ImageUploadInput";
import { toast } from "react-toastify";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

const ImageDiv = styled("div")`
  .delete-overlay {
    display: none;
  }
  &:hover .delete-overlay {
    display: block;
  }
`;

const hiararchies = [
  { name: "Company 1" },
  {
    name: "Parent company",
    children: [{ name: "Child 1" }, { name: "Child 2" }, { name: "Child 3" }],
  },
  {
    name: "Parent company",
    children: [{ name: "Child 1" }],
    departments: [{ name: "department 1" }, { name: "department 2" }],
  },
  {
    name: "Parent company",
    children: [
      {
        name: "Child 1",
        departments: [{ name: "department 1" }, { name: "department 2" }],
      },
    ],
    departments: [{ name: "department 1" }, { name: "department 2" }],
  },
  {
    name: "Parent company",
    children: [
      {
        name: "Child 1",
        departments: [{ name: "department 1" }, { name: "department 2" }],
      },
      {
        name: "Parent company",
        children: [
          { name: "Child 1" },
          { name: "Child 2" },
          { name: "Child 3" },
        ],
      },
    ],
    departments: [{ name: "department 1" }, { name: "department 2" }],
  },
];

function AccountOverviewSettings() {
  const [accountSettings, setAccountSettings] = useState({
    client_id: 2,
    country_id: 79,
    logo: "uploads/images/2/logo/Screenshot_from_2025-03-18_09-29-35.png",
    name: "logic",
    timezone: "Europe/London",
  });
  const { data } = useGetAccountSettingsDataQuery();

  useEffect(() => {
    if (data) {
      setAccountSettings(data);
    }
  }, [data]);
  const [errors, setErrors] = useState({});

  const handleAccountSettingsChange = (e) =>
    setAccountSettings((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

  const [save] = useUpdateAccountSettingsDataMutation(accountSettings);
  const handleSave = async () => {
    setErrors({});
    const response = await save({
      // system_guide: "Y",
      // system_wizard: "N",
      // section: "system_wide_settings",
      client_default_timezone: accountSettings.timezone,
      system_country: accountSettings.country_id,
      client_name: accountSettings.name,
      client_id: accountSettings.client_id,
      logo: accountSettings.logo,
    });
    if (response.error) {
      toast.error(response.error?.data?.message ?? "There is an error");
      setErrors(response.error?.data?.errors);
      return;
    }
    if (response.data.type === "success") {
      toast.success("Settings saved successfully");
    }
  };

  const defaultProductWidgetLayout = [
    { i: "./BoomcastWidget.jsx", x: 0, y: 0, w: 8, h: 10 },
    { i: "./BoomlogicWidget.jsx", x: 8, y: 0, w: 8, h: 10 },

    // { i: "./MessagesWidget.jsx", x: 4, y: 0, w: 4, h: 10 },
    // { i: "./MessagesProcessedWidget.jsx", x: 8, y: 0, w: 4, h: 10 },
    // { i: "./SystemUsageWidget.jsx", x: 12, y: 0, w: 4, h: 10 },
    // { i: "./BillingWidget.jsx", x: 16, y: 0, w: 4, h: 10 },
  ];

  const [clearLogo] = useClearCompanyLogoMutation();

  return (
    <div className="mb-5">
     
      <Subheading
        Icon={AccountOverviewIcon}
        heading="Account Contact"
        subheading="Control your account name, country preferences and application logo."
      />

      <Row xs={1} xl={2} className="my-3">
        <Col>
          <InterfaceSetup
            handleAccountSettingsChange={handleAccountSettingsChange}
            accountSettings={accountSettings}
            errors={errors}
          />
        </Col>
        <Col>
          <div className=" bg-purple-gradient-darker-reverse rounded-4 p-3">
            <>
              <h5 className=" d-flex align-items-center">
                <MyIcon Icon={CompanyDetailsIcon} className="me-2" />
                <span className="ms-2">
                  <span className="fw-bold me-2">Company Logo:</span>
                  <HelpButton helpKey="settings-account-overview-company-logo" />
                  <div className="small text-secondary">
                    Upload your company logo to personalise your application.
                  </div>
                </span>
              </h5>
              <hr className="my-3 text-secondary" />
            </>

            <Form>
              <Row>
                <Col>
                  <ImageDiv className="p-3 rounded-3 bg-white position-relative">
                    {/* <label>Company logo</label> */}
                    <ImageUploadInput
                      value={accountSettings.logo}
                      onChange={(url) =>
                        setAccountSettings((p) => ({ ...p, logo: url }))
                      }
                    />
                    {/* <div className="delete-overlay position-absolute top-0 start-0 w-100 h-100 bg-dark bg-opacity-75"> */}
                    <button
                      type="button"
                      className="btn btn-colored position-absolute top-0 end-0 p-2 text-white fw-bold"
                      onClick={clearLogo}
                    >
                      Remove <FontAwesomeIcon icon={faTrash} />
                    </button>
                    {/* </div> */}
                  </ImageDiv>
                </Col>
              </Row>
            </Form>
          </div>
        </Col>
        {/* <Col className="g-3">
          <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
            <>
              <h5 className=" d-flex align-items-center ">
                <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                <span className="ms-2">
                  <span className="fw-bold me-2"> My Products :</span>
                  <HelpButton helpKey="settings-account-overview-my-products" />
                  <div className="small text-secondary">
                    View the status of your Boomerang Products{" "}
                  </div>
                </span>
              </h5>
              <hr className="my-3 text-secondary" />
            </>

            <WidgetContainer
              lsField="products"
              defaultLayout={defaultProductWidgetLayout}
            />
          </div>
        </Col> */}
        {/* <Col className="g-3">
          <div className="bg-purple-gradient-darker-reverse rounded-4 p-3 ">
            <>
              <h5 className=" d-flex align-items-center ">
                <MyIcon Icon={BillingDetailsIcon} className="me-2" />
                <span className="ms-2">
                  <span className="fw-bold me-2">
                    {" "}
                    Organisational Hierarchy :
                  </span>
                  <HelpButton helpKey="settings-account-overview-organisational-hierarchy" />
                  <div className="small text-secondary">
                    View the organisational hierarchy
                  </div>
                </span>
              </h5>
              <hr className="my-3 text-secondary" />
            </>

            {hiararchies.map((h) => (
              <OrganisationalHiararchy hiararchy={h} />
            ))}
          </div>
        </Col> */}
      </Row>
      <hr className="my-5 text-secondary" />
      <div className="d-flex justify-content-end">
        <button
          type="button"
          className="btn btn-colored-reverse rounded-pill fw-bold "
          onClick={handleSave}
        >
          <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
          SAVE SETTINGS
        </button>
      </div>
    </div>
  );
}

export default AccountOverviewSettings;
